import React, {Component} from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  Dimensions,
  Image,
} from 'react-native';
import {Intro} from '../components/Intro';
import {Header} from '../components/Header';
import {Footer} from '../components/Footer';
import Home from './Home';
import About from './About';
import Projects from './Projects';

export default class Holder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
    };
  }

  componentDidMount() {
    var pages = [Home, About];
  }
  setId = id => {
    this.setState({currentPage: id});
  };
  render() {
    return (
      <View style={{flex: 1, justifyContent: 'space-between'}}>
        <View>
          <Header callback={this.setId} />
          {this.state.currentPage == 0 ? (
            <Home />
          ) : this.state.currentPage == 1 ? (
            <About />
          ) : this.state.currentPage == 2 ? (
            <Projects />
          ) : null}
        </View>
        <Footer />
      </View>
    );
  }
}
